import { memo } from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import {
  CardTitle,
  ChartLoadingState,
  ChartTooltipBox,
  EmptyChartState,
  LegendPill,
  OVERVIEW_CARD_SX,
} from './OverviewCard';

const DONUT_SIZE = 132;

const renderTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) {
    return null;
  }

  const item = payload[0].payload;

  return (
    <ChartTooltipBox>
      {item.label}: {item.valueLabel ?? item.value}
    </ChartTooltipBox>
  );
};

const StatusDonutChart = ({
  title,
  subtitle,
  data = [],
  titleSize = 'md',
  onItemClick,
  isLoading,
  emptyMessage = 'No data yet',
  sx,
}) => (
  <Stack gap={1} sx={{ ...OVERVIEW_CARD_SX, minWidth: 0, ...sx }}>
    <CardTitle title={title} subtitle={subtitle} size={titleSize} />

    {isLoading ? (
      <ChartLoadingState height={DONUT_SIZE} />
    ) : !data.length ? (
      <EmptyChartState height={DONUT_SIZE} message={emptyMessage} />
    ) : (
      <>
        <Box sx={{ width: DONUT_SIZE, height: DONUT_SIZE, alignSelf: 'center' }}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                dataKey="value"
                nameKey="label"
                innerRadius={38}
                outerRadius={62}
                paddingAngle={2}
                cursor={onItemClick ? 'pointer' : 'default'}
                onClick={entry => onItemClick?.(entry?.payload ?? entry)}>
                {data.map(entry => (
                  <Cell key={entry.name} fill={entry.color} stroke="#454545" strokeWidth={1} />
                ))}
              </Pie>
              <Tooltip isAnimationActive={false} content={renderTooltip} />
            </PieChart>
          </ResponsiveContainer>
        </Box>

        <Stack direction="row" gap={0.5} flexWrap="wrap" justifyContent="center">
          {data.map(entry => (
            <LegendPill
              key={entry.name}
              color={entry.color}
              label={entry.label}
              value={entry.valueLabel ?? entry.value}
              onClick={onItemClick ? () => onItemClick(entry) : undefined}
            />
          ))}
        </Stack>
      </>
    )}
  </Stack>
);

export default memo(StatusDonutChart);
